import type { Language } from '@eformulieren/engine'

/**
 * De pod weigert de samenwerkverbinding omdat deze pagina van een oorsprong komt die niet in zijn
 * lijst staat (`herkomst-niet-toegestaan`, 4009, `CLOSE_REASONS` in `apps/runtime/src/collaboration.ts`,
 * opdracht van 1 november 2026).
 *
 * Dat is een instelling van de pod (`RUNTIME_TOEGESTANE_ORIGINS`) en geen kwestie van toegang: tot deze
 * opdracht sloot de pod met 4005, de code van `toegang-ingetrokken`, en dan zei deze pagina de invuller
 * dat zijn toegang was beëindigd. Het is ook eindstand: opnieuw verbinden helpt niet zolang de instelling
 * niet is aangepast, dus de pagina stopt en zegt in gewone taal wat er aan de hand is.
 *
 * Dit bestand is `window`-vrij, zodat de beslissingen in Node te toetsen zijn (dezelfde keuze als
 * `access.ts` en `rateLimited.ts`).
 */

const ORIGIN_REJECTED = { code: 4009, reden: 'herkomst-niet-toegestaan' } as const

/** Of deze sluiting een geweigerde oorsprong is; op code of reden, net als `isEndOfAccess`. */
export function isOriginRejectedClose(closing: { readonly code?: number; readonly reason?: string } | undefined): boolean {
  if (closing === undefined) return false
  return closing.code === ORIGIN_REJECTED.code || closing.reason === ORIGIN_REJECTED.reden
}

const TEXT = {
  titel: {
    nl: 'Dit formulier kan geen verbinding maken',
    en: 'This form cannot connect',
  },
  uitleg: {
    nl: 'De server van dit formulier accepteert geen verbinding vanaf het adres waarop u het formulier hebt geopend. Dat is een technische instelling. Het ligt niet aan u, en aan uw toegang tot het formulier is niets veranderd.',
    en: 'The server of this form does not accept a connection from the address at which you opened the form. This is a technical setting. It is not caused by you, and nothing has changed about your access to the form.',
  },
  wat: {
    nl: 'Opnieuw proberen helpt niet tot de instelling is aangepast. Meld het bij NWO, met het adres van deze pagina erbij.',
    en: 'Trying again will not help until the setting has been corrected. Please report it to NWO, together with the address of this page.',
  },
} as const

export function originRejectedText(language: Language): { titel: string; uitleg: string; wat: string } {
  return { titel: TEXT.titel[language], uitleg: TEXT.uitleg[language], wat: TEXT.wat[language] }
}
